/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-03-17 18:29:01
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AllPhotoState {
  photoListActiveTab: 'content' | 'location' | 'precise'
}

const initialState: AllPhotoState = {
  photoListActiveTab: 'content'
}

const allPhotoSlice = createSlice({
  name: 'allPhoto',
  initialState,
  reducers: {
    setPhotoListActiveTab: (
      state,
      action: PayloadAction<'content' | 'location' | 'precise'>
    ) => {
      state.photoListActiveTab = action.payload
    },
    reset: () => initialState
  }
})

export const { setPhotoListActiveTab, reset } = allPhotoSlice.actions

export default allPhotoSlice.reducer
